import {Adjunto, AdjuntoTableColumn, AdjuntoTableRowSource} from "../models";
import {formatValue, TableRow, TableValueType} from "../../shared";

export function createAdjuntoTableRow(adjunto: Adjunto, columns: AdjuntoTableColumn[],
                                      sources: AdjuntoTableRowSource): TableRow {
  const row: TableRow = {
    __source__: adjunto
  };
  for (const column of columns) {
    switch (column.type) {
      case TableValueType.ACTION:
        row[column.name] = column.actionFormat
          ? column.actionFormat(adjunto, sources)
          : {value: column.name, text: column.name, icon: 'bomb'};
        break;
      case TableValueType.LITERAL:
        row[column.name] = column.literalFormat ? column.literalFormat(adjunto[column.name], adjunto) : formatValue(adjunto[column.name], null);
        break;
    }
  }
  return row;
}
